import { render, staticRenderFns } from "./MyCoupon.vue?vue&type=template&id=2fb3fd80&scoped=true"
import script from "./MyCoupon.vue?vue&type=script&lang=js"
export * from "./MyCoupon.vue?vue&type=script&lang=js"
import style0 from "./MyCoupon.vue?vue&type=style&index=0&id=2fb3fd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb3fd80",
  null
  
)

export default component.exports